import React, { Component } from "react";
import { Field, Form } from "formik";
import { RadioButton, RadioButtonGroup } from "./RadioButton";
import "./AboutSigner.scss";
import { currentLocale } from "../locale";
import {
    SET_INVALID,
    SET_VALID,
    MARKETING_INFORMATION_COLLECTED
} from "../constants";
import { connect } from "react-redux";
import { converter } from "../lib/converter";
import { AboutSignerNotification } from "./modal";
import { isNil } from "ramda";

class AboutSigner extends Component {
    state = {
        lat: "",
        lng: "",
        stateParticipantData: {
            role: "",
            optIn: true //already chosen
        }
    };

    componentWillMount() {
        this.props.getPathParticipants();
        const { values } = this.props.formikProps;
        const hasContactInfo = this.props.waiver.getPhone || this.props.waiver.getEmail || this.props.waiver.getAddress;
        if (hasContactInfo || this.props.waiver.iceNumber) {
            this.props.dispatch({
                type: MARKETING_INFORMATION_COLLECTED,
                payload: {
                    phoneNumber: values.phoneNumber,
                    optIn: values.optIn,
                    icePhoneNumber: values.icePhoneNumber,
                    email: values.email,
                    messagingOptIn: values.messagingOptIn,
                    address: values.address

                }
            });
        }
        if (this.props.signingInfo.role === 0) {
            this.props.dispatch({ type: SET_INVALID, payload: false });
        } else {
            this.props.dispatch({ type: SET_VALID, payload: true });
        }
    }

    render() {
        const { values, errors, touched, onRoleChange } = this.props;
        return (
            <React.Fragment>
                {/* {equals(false, this.props.selected) ? ( */}
                {isNil(this.props.selected) ? (
                    <AboutSignerNotification>
                        {converter.convert(currentLocale.selectionAlert)}
                    </AboutSignerNotification>
                ) : null}
                <div className="rolename-radio-button">
                    <Form
                        className="radio-button-form"
                        onChange={e => onRoleChange(e.target.value)}
                    >
                        <RadioButtonGroup
                            className="radio-button-group"
                            id="role"
                            value={values.role}
                            error={errors.role}
                            touched={touched.role}
                        >
                            <Field
                                component={RadioButton}
                                name="role"
                                id="1" //role: isParticipant
                                label={converter.convert(currentLocale.isParticipant)}
                            />
                            <Field
                                component={RadioButton}
                                name="role"
                                id="2" //role: isGuardian
                                label={converter.convert(currentLocale.isGuardian)}
                            />
                            <Field
                                component={RadioButton}
                                name="role"
                                id="3" //role: isBoth
                                label={converter.convert(currentLocale.isBoth)}
                            />
                        </RadioButtonGroup>
                    </Form>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    selected: state.signingInfo.selected
});

const mapActionToProps = dispatch => ({
    dispatch
});

export default connect(
    mapStateToProps,
    mapActionToProps
)(AboutSigner);
